document.addEventListener('DOMContentLoaded', function() {
  const featuresContainer = document.querySelector('.features-container');
  const prevButton = document.querySelector('.features-nav--prev');
  const nextButton = document.querySelector('.features-nav--next');
  const indicators = document.querySelectorAll('.features-indicator');
  const features = document.querySelectorAll('.product_feature');
  
  if (!featuresContainer || !prevButton || !nextButton || features.length === 0) {
    console.log('Features carousel elements not found or no features available');
    return;
  }

  let currentIndex = 0;
  const totalFeatures = features.length;
  const featuresPerView = 1; // Number of features visible at once
  const maxIndex = Math.max(0, totalFeatures - featuresPerView);

  // Hide navigation if there's only one feature or less
  if (totalFeatures <= featuresPerView) {
    prevButton.style.display = 'none';
    nextButton.style.display = 'none';
    const indicatorsContainer = document.querySelector('.features-indicators');
    if (indicatorsContainer) {
      indicatorsContainer.style.display = 'none';
    }
    return;
  }

  // Update button states
  function updateButtonStates() {
    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex >= maxIndex;
  }

  // Update indicators
  function updateIndicators() {
    indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === currentIndex);
    });
  }

  // Scroll to current feature
  function scrollToFeature(index) {
    const featureWidth = features[0].offsetWidth + 12; // width + gap
    const scrollPosition = index * featureWidth;
    featuresContainer.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
  }

  // Go to previous feature
  function goToPrevious() {
    if (currentIndex > 0) {
      currentIndex--;
      scrollToFeature(currentIndex);
      updateButtonStates();
      updateIndicators();
    }
  }

  // Go to next feature
  function goToNext() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      scrollToFeature(currentIndex);
      updateButtonStates();
      updateIndicators();
    }
  }

  // Go to specific feature
  function goToFeature(index) {
    if (index >= 0 && index <= maxIndex) {
      currentIndex = index;
      scrollToFeature(currentIndex);
      updateButtonStates();
      updateIndicators();
    }
  }

  // Event listeners
  prevButton.addEventListener('click', goToPrevious);
  nextButton.addEventListener('click', goToNext);

  // Indicator click events
  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', () => goToFeature(index));
    
    // Keyboard support for indicators
    indicator.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goToFeature(index);
      }
    });
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goToPrevious();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      goToNext();
    }
  });

  // Touch/swipe support
  let startX = 0;
  let startY = 0;
  let isScrolling = false;

  featuresContainer.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isScrolling = false;
  });

  featuresContainer.addEventListener('touchmove', (e) => {
    if (!startX || !startY) return;
    
    const diffX = Math.abs(e.touches[0].clientX - startX);
    const diffY = Math.abs(e.touches[0].clientY - startY);
    
    if (diffX > diffY) {
      isScrolling = true;
      e.preventDefault();
    }
  });

  featuresContainer.addEventListener('touchend', (e) => {
    if (!startX || !startY || !isScrolling) return;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    const threshold = 50;

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        goToNext();
      } else {
        goToPrevious();
      }
    }

    startX = 0;
    startY = 0;
    isScrolling = false;
  });

  // Initialize
  updateButtonStates();
  updateIndicators();

  // Handle window resize
  window.addEventListener('resize', () => {
    scrollToFeature(currentIndex);
  });
});
